import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.entries.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { browserTracingIntegration, WINDOW, startBrowserTracingPageLoadSpan, startBrowserTracingNavigationSpan } from '@sentry/browser';
import { SEMANTIC_ATTRIBUTE_SENTRY_OP, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE } from '@sentry/core';

/**
 * A custom browser tracing integration for TanStack Router.
 *
 * The minimum compatible version of `@tanstack/router` is `1.34.5`.
 *
 * @param router A TanStack Router `Router` instance that should be used for routing instrumentation.
 * @param options Sentry browser tracing configuration.
 */
function tanstackRouterBrowserTracingIntegration(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
router) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var castRouterInstance = router;
  var browserTracingIntegrationInstance = browserTracingIntegration(_objectSpread(_objectSpread({}, options), {}, {
    instrumentNavigation: false,
    instrumentPageLoad: false
  }));
  var _options$instrumentPa = options.instrumentPageLoad,
    instrumentPageLoad = _options$instrumentPa === void 0 ? true : _options$instrumentPa,
    _options$instrumentNa = options.instrumentNavigation,
    instrumentNavigation = _options$instrumentNa === void 0 ? true : _options$instrumentNa;
  return _objectSpread(_objectSpread({}, browserTracingIntegrationInstance), {}, {
    afterAllSetup: function afterAllSetup(client) {
      browserTracingIntegrationInstance.afterAllSetup(client);
      var initialWindowLocation = WINDOW.location;
      if (instrumentPageLoad && initialWindowLocation) {
        var _objectSpread2;
        var matchedRoutes = castRouterInstance.matchRoutes(initialWindowLocation.pathname, castRouterInstance.options.parseSearch(initialWindowLocation.search), {
          preload: false,
          throwOnError: false
        });
        var lastMatch = matchedRoutes[matchedRoutes.length - 1];
        startBrowserTracingPageLoadSpan(client, {
          name: lastMatch ? lastMatch.routeId : initialWindowLocation.pathname,
          attributes: _objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, SEMANTIC_ATTRIBUTE_SENTRY_OP, 'pageload'), _defineProperty(_objectSpread2, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.pageload.react.tanstack_router'), _defineProperty(_objectSpread2, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, lastMatch ? 'route' : 'url'), _objectSpread2), routeMatchToParamSpanAttributes(lastMatch))
        });
      }
      if (instrumentNavigation) {
        // The onBeforeNavigate hook is called at the very beginning of a navigation and is only called once per navigation, even when the user is redirected
        castRouterInstance.subscribe('onBeforeNavigate', function (onBeforeNavigateArgs) {
          var _attributes;
          // onBeforeNavigate is called during pageloads. We can avoid creating navigation spans by comparing the states of the to and from arguments.
          if (onBeforeNavigateArgs.toLocation.state === onBeforeNavigateArgs.fromLocation.state) {
            return;
          }
          var onResolvedMatchedRoutes = castRouterInstance.matchRoutes(onBeforeNavigateArgs.toLocation.pathname, onBeforeNavigateArgs.toLocation.search, {
            preload: false,
            throwOnError: false
          });
          var onBeforeNavigateLastMatch = onResolvedMatchedRoutes[onResolvedMatchedRoutes.length - 1];
          var navigationLocation = WINDOW.location;
          var navigationSpan = startBrowserTracingNavigationSpan(client, {
            name: onBeforeNavigateLastMatch ? onBeforeNavigateLastMatch.routeId : navigationLocation.pathname,
            attributes: (_attributes = {}, _defineProperty(_attributes, SEMANTIC_ATTRIBUTE_SENTRY_OP, 'navigation'), _defineProperty(_attributes, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.navigation.react.tanstack_router'), _defineProperty(_attributes, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, onBeforeNavigateLastMatch ? 'route' : 'url'), _attributes)
          });

          // In case the user is redirected during navigation we want to update the span with the right value.
          var unsubscribeOnResolved = castRouterInstance.subscribe('onResolved', function (onResolvedArgs) {
            unsubscribeOnResolved();
            if (navigationSpan) {
              var _onResolvedMatchedRoutes = castRouterInstance.matchRoutes(onResolvedArgs.toLocation.pathname, onResolvedArgs.toLocation.search, {
                preload: false,
                throwOnError: false
              });
              var onResolvedLastMatch = _onResolvedMatchedRoutes[_onResolvedMatchedRoutes.length - 1];
              if (onResolvedLastMatch) {
                navigationSpan.updateName(onResolvedLastMatch.routeId);
                navigationSpan.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, 'route');
                navigationSpan.setAttributes(routeMatchToParamSpanAttributes(onResolvedLastMatch));
              }
            }
          });
        });
      }
    }
  });
}
function routeMatchToParamSpanAttributes(match) {
  if (!match) {
    return {};
  }
  var paramAttributes = {};
  Object.entries(match.params).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    paramAttributes["url.path.params.".concat(key)] = value;
  });
  return paramAttributes;
}
export { tanstackRouterBrowserTracingIntegration };